angular.module('dnecom')
    .service('RequestUtils', function () {
        var objectToElements = function (obj, form, namespace) {
            var fd = form || {};
            var formKey;

            for (var property in obj) {
                if (obj.hasOwnProperty(property)) {
                    if (!obj[property]) {
                        obj[property] = null;
                    }

                    if (namespace) {
                        formKey = namespace + '[' + property + ']';
                    } else {
                        formKey = property;
                    }

                    if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
                        objectToElements(obj[property], fd, property);
                    } else {
                        fd[formKey] = obj[property];
                    }
                }
            }

            return fd;
        };

        return {
            post: function (url, data) {
                var $form = $('<form></form>');

                $form.attr('method', 'post');
                $form.attr('action', url);

                var payload = objectToElements(data);

                for(var key in payload) {
                    if (!payload.hasOwnProperty(key)) {
                        continue;
                    }

                    $form.append($('<input type="hidden"/>').attr('name', key).attr('value', payload[key]));
                }

                $('body').append($form);

                $form.submit();
                $form.remove();
            }
        }
    });
